import dayjs from "dayjs";
import times from "lodash/times";

export const getMonths = (start: dayjs.Dayjs, end: dayjs.Dayjs) => {
  const monthsCount = end.diff(start, "months") + 1;
  const months = times(monthsCount, month => {
    return dayjs(start).add(month, "month");
  });

  return months;
};
